<template>
  <b-form-group :label="vns.name ? vns.name : ''" label-for="select-action">
    <b-select id="select-action" v-model="action_select" :options="options" class="mb-2"/>
    <b-button variant="primary" @click="sendAction" block>
      {{ $t('monitoramento.resumo.tabs.comandos.atividade.send_button') }}
    </b-button>
  </b-form-group>
</template>

<script>
import VnsCommand from "@/repositories/vns/VnsCommandRepository";

export default {
  name: "FormTriggerActivity",
  props: {
    vns: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      action_select: null,
      options: [
        { value: 'REBOOT', text: 'Resetar VNS' },
        { value: 'REBOOT_PS_TRANSFER', text: 'Resetar PS Transfer' },
        { value: 'REBOOT_VEUS_BRIDGE', text: 'Resetar Veus Bridge' },
        { value: 'REBOOT_DISPLAY', text: 'Resetar Display' }
      ]
    }
  },
  methods: {
    sendAction() {
      let params = {vnsName: this.vns.name}      
      params['action'] = this.action_select
      
      VnsCommand.sendAction(params).then(response => {
        this.$snotify.success( this.$t('monitoramento.resumo.tabs.comandos.atividade.sucesso') )
        this.action_select = null
      }).catch(erro => {
        this.$snotify.error( this.$t('monitoramento.resumo.tabs.comandos.atividade.error') )
        console.log(erro)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
#select-action{
  border-bottom-right-radius: 0px;
  border-top-right-radius: 0px;
}
</style>
